import { render, staticRenderFns } from "./top-recommend.vue?vue&type=template&id=5e41c141&scoped=true"
import script from "./top-recommend.vue?vue&type=script&lang=js"
export * from "./top-recommend.vue?vue&type=script&lang=js"
import style0 from "./top-recommend.vue?vue&type=style&index=0&id=5e41c141&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e41c141",
  null
  
)

export default component.exports